// Copyright ©️ 2026 eVolve MEP, LLC

import { createModalRegistry } from 'components/Mantine/Modals/createModalRegistry';
import { CreateEditTaskTypeModal } from 'modules/Shop/Tasks/TaskTypes/CreateEditTaskType/CreateEditTaskTypeModal';
import { DeleteTaskTypeModal } from 'modules/Shop/Tasks/TaskTypes/DeleteTaskTypeModal';
import { ManageTaskGroupsModal } from 'modules/Shop/Tasks/TaskTypes/ManageTaskGroupsModal';

export const [TaskTypeModalProvider, useTaskTypeModals] = createModalRegistry({
  CreateEditTaskTypeModal,
  DeleteTaskTypeModal,
  ManageTaskGroupsModal,
});
